import React, { useState, useEffect, useContext } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { withNamespaces } from 'react-i18next';

import TopNav from "./components/TopNav";
import Footer from "./components/Footer";
import MobileNavigation from "./components/MobileNavigation";
import CurrencyModal from "./components/CurrencyModal";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ErrorBoundary from "./ErrorBoundary";
import Home from "./screens/Home";
import Wallet from "./screens/Wallet";
import Tasks from "./screens/Tasks";
import Levels from "./pages/Levels";
import Agents from "./pages/Agents";
import Referral from "./pages/Referral";
import Transacts from "./pages/Transacts";
import Groups from "./pages/Groups";
import Notifications from "./pages/Notifications";
import { AuthContext } from "./context/AuthContext";
import Login from "./screens/Login";
import Register from "./screens/Register";
import VerifyEmail from "./screens/VerifyEmail";
import ForgotPassword from "./screens/ForgotPassword";
import ResetPassword from "./screens/ResetPassword";
import Logout from './Logout';
import Deposit from "./screens/Deposit";
import Withdraw from "./screens/Withdraw";

const PrivateRoute = ({ element, ...props }) => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? element : <Navigate to="/login" />;
};

const PublicRoute = ({ element, ...props }) => {
  const { currentUser } = 'null';
  return currentUser ? <Navigate to="/" /> : element;
};

const Layout = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const currency = localStorage.getItem("currency");
    if (!currency) {
      setShowModal(true);
    }
  }, []);

  return (
    <div className="bg-white flex flex-col h-screen w-full">
      {showModal && <CurrencyModal onClose={() => setShowModal(false)} />}
      <div className="main">
        <div className="animated Gradient" />
      </div>
      {/* Top Navigation */}
      <TopNav />


      <div className="app flex flex-col h-full overflow-y-auto scrollbar-hide items-center w-full">
        {/* Main */}
        <main className="flex flex-col h-full 2xl:w-[1480px] max-xl:w-[1280px] lg:w-[1080px] max-md:w-full px-2 gap-1 overflow-y-auto scrollbar-hide mx-auto">
          <Outlet />
        </main>

        <div className="max-md:hidden justify-end flex flex-col w-full h-fit bg-rose-500 items-center text-white">
          <Footer />
        </div>
      </div>

      {/* Bottom mobile navigation */}
      <MobileNavigation />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/wallet",
        element: <PrivateRoute element={<Wallet />} />,
      },
      {
        path: "/tasks",
        element: <PrivateRoute element={<Tasks />} />,
      },
      {
        path: "/levels",
        element: <Levels />,
      },
      {
        path: "/agents",
        element: <Agents />,
      },
      {
        path: "/referral",
        element: <PrivateRoute element={<Referral />} />,
      },
      {
        path: "/transacts",
        element: <PrivateRoute element={<Transacts />} />,
      },
      {
        path: "/groups",
        element: <Groups />,
      },
      {
        path: "/terms-and-condition",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/notifications",
        element: <Notifications />,
      },

      // Payment Issues
      {
        path: "/deposit",
        element: <PrivateRoute element={<Deposit />} />,
      },
      {
        path: "/withdraw",
        element: <PrivateRoute element={<Withdraw />} />,
      },
    ]
  },
  {
    children: [
      {
        path: "/login",
        element: <PublicRoute element={<Login />} />,
      },
      {
        path: "/register",
        element: <PublicRoute element={<Register />} />,
      },
      {
        path: "/verify-email",
        element: <PublicRoute element={<VerifyEmail />} />,
      },
      {
        path: "/forgot-password",
        element: <PublicRoute element={<ForgotPassword />} />,
      },
      {
        path: "/reset-password",
        element: <PublicRoute element={<ResetPassword />} />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
    ]
  }
]);

const App = () => {
  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
};

export default withNamespaces()(App);